import { Creators as AllCreators } from "./";

export const Creators = (AllCreators as any).App.SelectOrganization;
